<script>
export default {
  name: 'cmpt-dummy-overlay',
};
</script>



// WEBPACK FOOTER //
// src/components/ui/overlay/cmpt-dummy-overlay.vue